export enum PaymentOption {
    CASH_PAYMENT = 1,
    TRANSFER = 2,
    DIRECT_DEBIT = 3,
    PAYPAL = 4,
    CASH_CARD = 5,
    CREDIT_CARD = 6,
    TRANSFER_WISE = 7,
}
